import {axiosInstanceWithToken}  from "../utils/Client";

export default class ReportService {
    
    static getkpiExplanationReport = (kpiList, staffName, dateRange) => {
        let url = `/report/kpi_explanations/?kpi_list=[${kpiList}]&staff_name=${staffName}&compensation_date_range=${dateRange}`;

        return axiosInstanceWithToken.get(url);
    };

    static getCompensationPeriods = (compProfileId) => {
        
        return axiosInstanceWithToken.get(`/compensation_period/${compProfileId}/`);
    };

    static getCompensationIncomes = (compProfileId) => {
        
        return axiosInstanceWithToken.get(`/compensation_incomes/${compProfileId}/`);
    };

    static getCompensationPayments = (compProfileId) => {
        
        return axiosInstanceWithToken.get(`/compensation_payment/list/${compProfileId}/`);
    };

    static updateCompensationPayments = (compProfileId, compensationPayments) => {
        
        return axiosInstanceWithToken.put(
            `/compensation_payment/${compProfileId}/`, compensationPayments
        );
    };

    static getRevenueActual = (compProfileId) => {
        
        return axiosInstanceWithToken.get(`/report/revenue_actual/${compProfileId}/`);
    };

    static getCompensationSetting = (compProfileId) => {
        
        return axiosInstanceWithToken.get(`/report/compensation_setting/${compProfileId}/`);
    };

    static updateCompensationSetting = (compProfileId, data) => {
        
        return axiosInstanceWithToken.patch(
            `/report/compensation_setting/${compProfileId}/`, data
        );
    };

    static updateRevenueActual = (compProfileId, revenueActualData) => {
        
        return axiosInstanceWithToken.put(
            `/report/revenue_actual/${compProfileId}/`, revenueActualData
        );
    };

    static getRevenueGoal = (compProfileId) => {
        
        return axiosInstanceWithToken.get(`/report/revenue_goal/${compProfileId}/`);
    };

    static updateRevenueGoal = (compProfileId, revenueGoalData) => {
        
        return axiosInstanceWithToken.put(
            `/report/revenue_goal/${compProfileId}/`, revenueGoalData
        );
    };

    static getKPIDataList = (
        agencyLocation, fromDate, toDate, kpiIdList, userIdList, dataType
    ) => {
        let url = '';
        if (dataType === 'PDF') {
            url = `/report/kpi_data/${agencyLocation}/?start_date=${fromDate}&end_date=${toDate}&kpi_list=[${kpiIdList}]&user_list=[${userIdList}]`;
        } else {
            url = `/report/kpi_data/list/${agencyLocation}/?start_date=${fromDate}&end_date=${toDate}&kpi_list=[${kpiIdList}]&user_list=[${userIdList}]`;
        }
        
        return axiosInstanceWithToken.get(url);
    };

    static getUserList = () => {
        return axiosInstanceWithToken.get(`/user/`);
    };
}



// WEBPACK FOOTER //
// ./src/services/ReportService.js